export default "__VITE_ASSET__yGKtRg4y__"